import { useEffect } from 'react'
import { SimpleLinkService } from 'pdfjs-dist/lib/web/pdf_link_service'
const PDFJS = require('pdfjs-dist/web/pdf_viewer')

export const useMutationObserver = (node, observerFn, options) => {
  useEffect(() => {
    if (node.current) {
      const observer = new MutationObserver(observerFn)
      observer.observe(node.current, options)
      return () => {
        observer.disconnect()
      }
    }
  }, [node.current, observerFn, options])
}

const deleteAllChildNodes = node => {
  while (node.firstChild) {
    node.removeChild(node.firstChild)
  }
}

export const updateAnnotationLayer = div => _mutations => {
  window.requestAnimationFrame(() => {
    setTimeout(() => {
      const anchors = div.current.getElementsByTagName('a')
      for (let i = 0; i < anchors.length; i++) {
        if (anchors[i].getAttribute('target') !== '_blank') {
          anchors[i].setAttribute('target', '_blank')
        }
      }

      const dateStrings = document.querySelectorAll(
        '[data-l10n-id="annotation_date_string"]'
      )
      for (let i = 0; i < dateStrings.length; i++) {
        try {
          const obj = JSON.parse(dateStrings[i].getAttribute('data-l10n-args'))
          const date = new Date(`${obj.date} ${obj.time}`)
          const localizedDate = date.toLocaleDateString(undefined, {
            hour: 'numeric',
            minute: 'numeric'
          })
          if (localizedDate !== dateStrings[i].textContent) {
            dateStrings[i].textContent = localizedDate
          }
        } catch (error) {
          console.warn(`Could not render PDF annotation datetime`, error)
        }
      }
    }, 1)
  })
}

export const renderPDFAnnotationLayer = (div, pdfPage, viewport) => {
  if (!(div.current instanceof HTMLElement)) {
    console.warn('<div> was not ready in PDFAnnotationLayer')
    return
  }
  deleteAllChildNodes(div.current)

  const annotationLayer = new PDFJS.AnnotationLayerBuilder({
    pageDiv: div.current,
    pdfPage,
    renderInteractiveForms: false,
    linkService: new SimpleLinkService(),
    imageResourcesPath: '/pdfjs/images/'
  })
  annotationLayer.render(viewport)
}
